export default __webpack_public_path__ + "static/media/Boots of the Ravenflight.e93b1390.jpg";